export enum ExtraButtonAction {
  Disable = 'disable',
  Enable = 'enable',
  DisableAll = 'disableAll',
  EnableAll = 'enableAll'
}

export interface ExtraButtonsProps {
  selectedRows: string[];
  onDisableAll: () => void;
  onEnableAll: () => void;
  onDisable: () => void;
  onEnable: () => void;
}
